import React, { useState } from "react";

import Dialog from "@mui/material/Dialog";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  animate: {
    animation: `$fade-in-keyframes 0.12s`,
    animationIterationCount: 4,
  },
  "@keyframes fade-in-keyframes": {
    "0%": { boxShadow: "rgba(0, 0, 0, 0.75) 0px 5px 10px" },
    "50%": { boxShadow: "rgba(0, 0, 0, 0.75) 0px 5px 30px" },
    "100%": { boxShadow: "none" },
  },
});

const KMKDialog = (props) => {
  const { classes } = useStyles();

  const [animate, setAnimate] = useState(false);
  return (
    <Dialog
      onClose={() => setAnimate(true)}
      onAnimationEnd={() => setAnimate(false)}
      sx={{
        "& .MuiPaper-root": {
          WebkitTransition: "0.5s",
          MozTransition: "0.5s",
          transition: "0.5s",
        },
      }}
      classes={{
        paper: animate ? classes.animate : "",
      }}
      keepMounted
      {...props}
    >
      {props.children}
    </Dialog>
  );
};

export default React.memo(KMKDialog);
